import PropTypes from "prop-types";

const CheckboxList = ({  type = "checkbox", id, name, checked = false, style, onChange, control }) => {
                        const { field } = control
                        return <input  {...field} type={type} id={id} name={name} checked={checked} style={style} onChange={onChange} />
                    };

CheckboxList.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  control: PropTypes.object,
};

export default CheckboxList;
